import React from 'react';
import styled from 'styled-components';
import css from '@styled-system/css';
import { Box, Text } from '../primitives';
import rem from '../../utils/rem';

export type TooltipPositions = 'left' | 'right' | 'top';

type Props = {
  label: string;
  position?: TooltipPositions;
};

export const Tooltip = ({ label, position = 'left', ...rest }: Props) => (
  <SBox
    display="inline-block"
    bg="primary"
    borderRadius={rem(4)}
    px={rem(12)}
    tooltipPosition={position}
    {...rest}
  >
    <Text variant="medium" color="light" whiteSpace="nowrap">
      {label}
    </Text>
  </SBox>
);

const SBox = styled(Box)<{ tooltipPosition: TooltipPositions }>`
  &:after {
    border: solid #ffffff00;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-width: 4px;
    margin-top: ${({ tooltipPosition }) =>
      tooltipPosition === 'top' ? '-8px' : '-4px'};
    margin-right: ${({ tooltipPosition }) =>
      tooltipPosition === 'top' ? '-4px' : '0px'};
    ${({ tooltipPosition }) =>
      css(
        tooltipPosition === 'left'
          ? {
              borderLeftColor: 'primary',
              left: '100%',
              top: '50%',
            }
          : tooltipPosition === 'right'
          ? {
              borderRightColor: 'primary',
              right: '100%',
              top: '50%',
            }
          : {
              borderTopColor: 'primary',
              right: '50%',
              top: '100%',
              transform: 'translateY(100%)',
            }
      ) as any}
  }
`;
